var ContainerSnapshot = (function () {
    function ContainerSnapshot() {
    }
    ContainerSnapshot.of = function (bindings, middleware, activations, deactivations, moduleActivationStore) {
        var snapshot = new ContainerSnapshot();
        snapshot.bindings = bindings;
        snapshot.middleware = middleware;
        snapshot.deactivations = deactivations;
        snapshot.activations = activations;
        snapshot.moduleActivationStore = moduleActivationStore;
        return snapshot;
    };
    return ContainerSnapshot;
}());
export { ContainerSnapshot };
//# sourceMappingURL=container_snapshot.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/container/container_snapshot.js
// module id = 1725
// module chunks = 0